// Transpose a single chord (for preview rendering)
export const transposeChord = (chord: string, semitones: number): string => {
  if (semitones === 0) return chord;

  const notes = ['C', 'C#', 'D', 'D#', 'E', 'F', 'F#', 'G', 'G#', 'A', 'A#', 'B'];
  const noteMatch = chord.match(/^([A-G][#b]?)(.*)/);

  if (!noteMatch) return chord;

  let [, root, suffix] = noteMatch;

  // Normalize flats to sharps
  root = root
    .replace('Db', 'C#')
    .replace('Eb', 'D#')
    .replace('Gb', 'F#')
    .replace('Ab', 'G#')
    .replace('Bb', 'A#');

  let index = notes.indexOf(root);
  if (index === -1) return chord;

  index = (index + semitones + 12) % 12;
  return notes[index] + suffix;
};

